/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { NoSSR } from "@sphtech/web2-core/components";
import {
  CustomContext,
  ResponseType,
  TRouteWithRedirect,
  useRouteContext,
} from "@sphtech/web2-core/ssr";
import { useEffect, useRef } from "react";

import ErrorPage from "../ErrorPage";

export default function OAuthCallbackPage() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const routeContext: CustomContext<TRouteWithRedirect<unknown, string>> =
    useRouteContext();
  const dataLoaderResponse = routeContext.context;

  useEffect(() => {
    if (canvasRef.current) {
      void import(
        "https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web/+esm"
      )
        .then(({ DotLottie }: any) => {
          new DotLottie({
            autoplay: true,
            loop: true,
            canvas: canvasRef.current as HTMLCanvasElement,
            src: "/lottie/preloader.json",
          });
        })
        .catch((error: unknown) => {
          console.error("Failed to load DotLottie animation:", error);
        });
    }
  }, []);

  if (dataLoaderResponse.type === ResponseType.SERVER_ERROR) {
    return <ErrorPage message="Something went wrong" />;
  }

  return (
    <NoSSR>
      <div style={{ textAlign: "center" }}>
        <div className="container">
          <div className="banner-animation">
            <canvas ref={canvasRef} id="canvas"></canvas>
          </div>
        </div>
      </div>
    </NoSSR>
  );
}
